import { useMemo } from 'react';
import { useAppSelector } from 'src/app/hooks';
import { IObject } from 'src/models/objectManagement';

// For checking is there any object that still not success from selected object id list
export const useInactiveObject = () => {
  const objectList = useAppSelector(
    (state) => state.objectManagement.objectList.data
  );

  // map object id list for faster lookup
  const objectById = useMemo(() => {
    const map = new Map<string, IObject>();

    for (const item of objectList) {
      map.set(item.id, item);
    }
    return map;
  }, [objectList]);

  const isInactiveObjectExist = (selectedObjectIds: string[]) => {
    return selectedObjectIds.some((id) => {
      const item = objectById.get(id);
      return item && item.status !== 'success';
    });
  };

  return { objectById, isInactiveObjectExist };
};
